import { cfRawTokens } from "./raw-tokens";

export const cfSemanticTheme = {
  bg: "var(--cf-void)",
  surface: "var(--cf-charcoal)",
  text: "var(--cf-concrete)",
  mutedText: "var(--cf-steel)",
  brand: "var(--cf-brand)",
  glow: "var(--cf-glow)",
  brandHover: "var(--cf-brand-hover)",
  danger: "var(--cf-error)",
  success: "var(--cf-success)",
  focusRing: "var(--cf-glow)",
} as const;

export type CFSemanticThemeKey = keyof typeof cfSemanticTheme;

export type CFThemeMode = "dark" | "light";

export type CFThemeColors = {
  bg: string;
  surface: string;
  text: string;
  mutedText: string;
  brand: string;
  brandHover: string;
  onBrand: string;
  focusRing: string;
  shadow: string;
  border: string;
  surfaceDisabled: string;
  status: {
    success: string;
    danger: string;
    info: string;
    warning: string;
  };
};

function withAlpha(hex: string, alpha: number) {
  const normalized = hex.replace("#", "");
  const value = Number.parseInt(normalized, 16);
  const r = (value >> 16) & 255;
  const g = (value >> 8) & 255;
  const b = value & 255;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export const cfThemeColors = {
  dark: {
    bg: cfRawTokens.color.neutral.void,
    surface: cfRawTokens.color.neutral.charcoal,
    text: cfRawTokens.color.neutral.concrete,
    mutedText: cfRawTokens.color.neutral.steel,
    brand: "#5aa9ff",
    brandHover: "#8ec4ff",
    onBrand: cfRawTokens.color.neutral.void,
    focusRing: "#7eb8ff",
    shadow: cfRawTokens.color.neutral.void,
    border: withAlpha(cfRawTokens.color.neutral.steel, 0.42),
    surfaceDisabled: withAlpha(cfRawTokens.color.neutral.charcoal, 0.72),
    status: {
      success: cfRawTokens.color.accent.success,
      danger: cfRawTokens.color.accent.error,
      info: cfRawTokens.color.accent.info,
      warning: cfRawTokens.color.primary.gold,
    },
  },
  light: {
    bg: "#f7fbff",
    surface: "#b0d6d7",
    text: "#11252b",
    mutedText: "#2f4a4f",
    brand: "#2f74b7",
    brandHover: "#61a8e9",
    onBrand: "#f7fbff",
    focusRing: "#78e2dd",
    shadow: "rgba(4, 38, 45, 0.16)",
    border: withAlpha("#2f4a4f", 0.42),
    surfaceDisabled: withAlpha("#b0d6d7", 0.72),
    status: {
      success: "#38d28a",
      danger: "#ff6b6b",
      info: "#5aa9ff",
      warning: cfRawTokens.color.primary.gold,
    },
  },
} as const satisfies Record<CFThemeMode, CFThemeColors>;
